import React, { useState, useEffect, useRef } from "react";
import noteIcon from "./img/note.webp";
import burgerIcon from "./img/menu-burger.png";
import { Button, Form, Row, Col } from "react-bootstrap";

import Modal from "react-bootstrap/Modal";
import { daysFactor, invisiblestring, statusfarben, statusfarbentext, eskalationsLevel } from "./globalVariables";


export default function ProjektstatusExpo({
   kacheln,
   heading,
   userObjects,
   abschnittsarray,
   showStatusStufen,
   updateStufenOptionen,
   topic,
}) {

   function calculateKachelStatus(item, kachelId) {
      let statusLevel = item.kachelstatus[kachelId];
      if (
         typeof item.kachelstatus[kachelId] !== "undefined" &&
         item.kachelstatus[kachelId] < eskalationsLevel &&
         item.eskalationen[kachelId] &&
         new Date(item.eskalationsDaten[kachelId]) < new Date()
      ) {
         statusLevel = -1;
      }

      return statusLevel;
   }

   return (
      <div
         className="projektstatus-l2 m-0"
         style={{
            /* position: "absolute", left: "-10px", top: "100px", height: "50px", overflow: "hidden", width: "60px" */ width: "100%",
         }}
      >
         <div style={{ position: "relative" }}>
            <button
               onClick={() => updateStufenOptionen({ key: topic, value: true })}
               className="clean-button "
               title="Bereich minimieren"
               style={{ position: "absolute", right: "10px" }}
            >
               _
            </button>
         </div>
         <h2>{abschnittsarray && abschnittsarray.length} In Vorlauf</h2>
         {abschnittsarray && (
            <div className="projekt-status-expo projektstatus-l3">
               <table
                  style={{
                     display: "block",
                     maxHeight: "90vh",
                     overflowY: "auto",
                     overflowX: "auto",
                     width: "100%",
                     padding: 0,
                  }}
               >
                  <thead style={{ position: "sticky", top: 0 }}>
                     <tr style={{ backgroundColor: "#fff" }}>
                        <th title="Vorankündigungsdatum" style={{ backgroundColor: "#000", color: "#fff" }}>
                           VA
                        </th>
                        <th
                           title="Tage seit Vollmachtenkachel abgeschlossen"
                           style={{ backgroundColor: "#000", color: "#fff" }}
                        >
                           VM
                        </th>
                        <th title="Tage vom/bis zum Fototermin" style={{ backgroundColor: "#000", color: "#fff" }}>
                           FT
                        </th>
                        <th title="Übernahme vom Makler">Über</th>
                        {/* <th title="Status der verschiedenen Fotoaufnahmen">Foto</th> */}
                        <th
                           title="Fotos (Innen, Außen, Drohne, Matterport, Ogulo, Reel)"
                           style={{ display: "flex", justifyContent: "space-evenly" }}
                        >
                           <span>FI</span>
                           <span>FA</span>
                           <span>FD</span>
                           <span>FM</span>
                           <span>FO</span>
                           <span>FR</span>
                        </th>

                        <th title="Aktueller Bearbeitungszustand der Stufe">Expo</th>
                        <th title="Liegt ein Exposé vor?" style={{ backgroundColor: "#000", color: "#fff" }}></th>
                        <th title="Exposé wurde versandt" style={{ backgroundColor: "#000", color: "#fff" }}></th>
                        <th title="Eskalationspause" style={{ backgroundColor: "#000", color: "#fff" }}>
                           EP
                        </th>
                        <th title="Objekt"></th>
                     </tr>
                  </thead>
                  <tbody>
                     {abschnittsarray
                        .sort((a, b) => {
                           if (a.vorankundigung && b.vorankundigung) {
                              if (a.vorankundigung < b.vorankundigung) {
                                 return -1;
                              } else {
                                 return 1;
                              }
                           } else if (a.vorankundigung) {
                              return -1;
                           } else {
                              return 1;
                           }
                        })
                        .map((item) => {
                           let va_days = Math.floor((new Date() - item.vorankundigung) / daysFactor);
                           let ft_days = Math.floor((new Date() - item.fototermin) / daysFactor);
                           let ex_days = Math.floor((new Date() - item.expoversandt) / daysFactor);
                           let vm_days = Math.floor((new Date() - item.vollmachtsdatum) / daysFactor);
                           let ftt_days = Math.floor((new Date() - item.fotoTerminAb) / daysFactor);

                           return (
                              <tr key={"expokey_" + item.objektnr_extern}>
                                 <td className="projektstatus-termin" style={{ background: "#000", padding: "0 8px" }}>
                                    {item.vorankundigung && (
                                       <div
                                          title={"Vorankündigung seit: " + item.vorankundigung.toLocaleString()}
                                          style={
                                             va_days < 14
                                                ? { color: "#000", backgroundColor: "#eee" }
                                                : {
                                                     textShadow: "0 0 2px #0009",
                                                     backgroundColor: `color-mix(in srgb, #f00 ${100 * Math.min(1, va_days / 28)}%, transparent)`,
                                                  }
                                          }
                                       >
                                          {/* VA{" "} */}
                                          {va_days}
                                       </div>
                                    )}
                                 </td>
                                 <td className="projektstatus-termin" style={{ background: "#000", padding: "0 8px" }}>
                                    {item.vollmachtsdatum && (
                                       <div
                                          title={"Vollmacht seit: " + item.vollmachtsdatum.toLocaleString()}
                                          style={
                                             true
                                                ? { color: "#000", backgroundColor: "#eee" }
                                                : {
                                                     textShadow: "0 0 2px #0009",
                                                     backgroundColor: `color-mix(in srgb, #f00 ${100 * Math.min(1, vm_days / 28)}%, transparent)`,
                                                  }
                                          }
                                       >
                                          {/* VA{" "} */}
                                          {vm_days}
                                       </div>
                                    )}
                                 </td>
                                 <td className="projektstatus-termin" style={{ background: "#000", padding: "0 8px" }}>
                                    {item.fototermin ? (
                                       <div
                                          title={"Fototermin am: " + item.fototermin.toLocaleString()}
                                          style={{ backgroundColor: "green" }}
                                          /* style={(new Date() - item.fototermin > 0) ? { backgroundColor: "green" } : {backgroundColor: "red"}} */
                                       >
                                          {ft_days}
                                       </div>
                                    ) : item.fotoTerminAb ? (
                                       <div style={{ color: "#fff", backgroundColor: ftt_days < 0 ? "#e80" : "#e00" }}>
                                          {ftt_days}
                                       </div>
                                    ) : (
                                       <div style={{ color: "#fff", backgroundColor: "#e00" }}>XX</div>
                                    )}
                                 </td>
                                 <td className="projektstatus-termin" style={{}}>
                                    <div>
                                       <a
                                          target="_blank"
                                          href={
                                             "/datenblatt?estateid=" + item.id + "&stufe=vollmacht&kachel=uebergabehm"
                                          }
                                          title="Übergabe Haus an Makler"
                                          style={{
                                             color: statusfarbentext[calculateKachelStatus(item, "uebergabehm")],
                                             backgroundColor: statusfarben[calculateKachelStatus(item, "uebergabehm")],
                                          }}
                                       >
                                          ÜH
                                       </a>

                                       <a
                                          target="_blank"
                                          href={
                                             "/datenblatt?estateid=" + item.id + "&stufe=vollmacht&kachel=uebernahmepm"
                                          }
                                          title="Übernahme vom Makler"
                                          style={{
                                             color: statusfarbentext[calculateKachelStatus(item, "uebernahmepm")],
                                             backgroundColor: statusfarben[calculateKachelStatus(item, "uebernahmepm")],
                                          }}
                                       >
                                          ÜM
                                       </a>
                                    </div>
                                 </td>

                                 <td className="projektstatus-termin" style={{}}>
                                    <div>
                                       <a
                                          target="_blank"
                                          href={"/datenblatt?estateid=" + item.id + "&stufe=fotografie&kachel=ft_innen"}
                                          title="Innenaufnahmen"
                                          style={{
                                             color: statusfarbentext[calculateKachelStatus(item, "ft_innen")],
                                             backgroundColor: statusfarben[calculateKachelStatus(item, "ft_innen")],
                                          }}
                                       >
                                          {item.eskalationsDaten["ft_innen"]
                                             ? Math.round(
                                                  (new Date(item.eskalationsDaten["ft_innen"]) - new Date()) /
                                                     daysFactor,
                                               )
                                             : invisiblestring}
                                       </a>
                                       <a
                                          target="_blank"
                                          href={
                                             "/datenblatt?estateid=" + item.id + "&stufe=fotografie&kachel=ft_aussen"
                                          }
                                          title="Außenaufnahmen"
                                          style={{
                                             color: statusfarbentext[calculateKachelStatus(item, "ft_aussen")],
                                             backgroundColor: statusfarben[calculateKachelStatus(item, "ft_aussen")],
                                          }}
                                       >
                                          {item.eskalationsDaten["ft_aussen"]
                                             ? Math.round(
                                                  (new Date(item.eskalationsDaten["ft_aussen"]) - new Date()) /
                                                     daysFactor,
                                               )
                                             : invisiblestring}
                                       </a>
                                       <a
                                          target="_blank"
                                          href={
                                             "/datenblatt?estateid=" + item.id + "&stufe=fotografie&kachel=ft_drohne"
                                          }
                                          title="Drohnenfotos"
                                          style={{
                                             color: statusfarbentext[calculateKachelStatus(item, "ft_drohne")],
                                             backgroundColor: statusfarben[calculateKachelStatus(item, "ft_drohne")],
                                          }}
                                       >
                                          {item.eskalationsDaten["ft_drohne"]
                                             ? Math.round(
                                                  (new Date(item.eskalationsDaten["ft_drohne"]) - new Date()) /
                                                     daysFactor,
                                               )
                                             : invisiblestring}
                                       </a>
                                       <a
                                          target="_blank"
                                          href={
                                             "/datenblatt?estateid=" +
                                             item.id +
                                             "&stufe=fotografie&kachel=ft_matterport"
                                          }
                                          title="Matterport"
                                          style={{
                                             color: statusfarbentext[calculateKachelStatus(item, "ft_matterport")],
                                             backgroundColor:
                                                statusfarben[calculateKachelStatus(item, "ft_matterport")],
                                          }}
                                       >
                                          {item.eskalationsDaten["ft_matterport"]
                                             ? Math.round(
                                                  (new Date(item.eskalationsDaten["ft_matterport"]) - new Date()) /
                                                     daysFactor,
                                               )
                                             : invisiblestring}
                                       </a>
                                       <a
                                          target="_blank"
                                          href={"/datenblatt?estateid=" + item.id + "&stufe=fotografie&kachel=ft_ogulo"}
                                          title="Ogulo"
                                          style={{
                                             color: statusfarbentext[calculateKachelStatus(item, "ft_ogulo")],
                                             backgroundColor: statusfarben[calculateKachelStatus(item, "ft_ogulo")],
                                          }}
                                       >
                                          {item.eskalationsDaten["ft_ogulo"]
                                             ? Math.round(
                                                  (new Date(item.eskalationsDaten["ft_ogulo"]) - new Date()) /
                                                     daysFactor,
                                               )
                                             : invisiblestring}
                                       </a>
                                       <a
                                          target="_blank"
                                          href={"/datenblatt?estateid=" + item.id + "&stufe=fotografie&kachel=ft_reel"}
                                          title="Reel"
                                          style={{
                                             color: statusfarbentext[calculateKachelStatus(item, "ft_reel")],
                                             backgroundColor: statusfarben[calculateKachelStatus(item, "ft_reel")],
                                          }}
                                       >
                                          {item.eskalationsDaten["ft_reel"]
                                             ? Math.round(
                                                  (new Date(item.eskalationsDaten["ft_reel"]) - new Date()) /
                                                     daysFactor,
                                               )
                                             : invisiblestring}
                                       </a>
                                    </div>
                                 </td>
                                 <td className="projektstatus-termin" style={{}}>
                                    <div>
                                       <a
                                          target="_blank"
                                          href={"/datenblatt?estateid=" + item.id + "&stufe=expobildererstellen"}
                                          title="Bilder erstellen und bearbeiten"
                                          style={{
                                             color: statusfarbentext[item.projektstufenstatus.expobildererstellen],
                                             backgroundColor:
                                                statusfarben[item.projektstufenstatus.expobildererstellen],
                                          }}
                                       >
                                          EB
                                       </a>
                                       <a
                                          target="_blank"
                                          href={"/datenblatt?estateid=" + item.id + "&stufe=expogrundriss"}
                                          title="Grundriss"
                                          style={{
                                             color: statusfarbentext[item.projektstufenstatus.expogrundriss],
                                             backgroundColor: statusfarben[item.projektstufenstatus.expogrundriss],
                                          }}
                                       >
                                          EG
                                       </a>
                                       <a
                                          target="_blank"
                                          href={"/datenblatt?estateid=" + item.id + "&stufe=expotext"}
                                          title="Text"
                                          style={{
                                             color: statusfarbentext[item.projektstufenstatus.expotext],
                                             backgroundColor: statusfarben[item.projektstufenstatus.expotext],
                                          }}
                                       >
                                          ET
                                       </a>
                                       <a
                                          target="_blank"
                                          href={"/datenblatt?estateid=" + item.id + "&stufe=expoerstellung"}
                                          title="Exposé erstellen"
                                          style={{
                                             color: statusfarbentext[item.projektstufenstatus.expoerstellung],
                                             backgroundColor: statusfarben[item.projektstufenstatus.expoerstellung],
                                          }}
                                       >
                                          EE
                                       </a>
                                    </div>
                                 </td>
                                 <td className="projektstatus-termin" style={{ background: "#000", padding: "0 8px" }}>
                                    <div>
                                       {item.expovorhanden && (
                                          <img
                                             style={{ filter: "invert(1)" }}
                                             src={noteIcon}
                                             title="Ein Exposé wurde erstellt."
                                             height="14px"
                                             alt="expo wurde erstellt"
                                          />
                                       )}
                                    </div>
                                 </td>
                                 <td className="projektstatus-termin" style={{ background: "#000", padding: "0 8px" }}>
                                    {item.expoversandt && (
                                       <div
                                          title={"Exposé wurde am: " + item.expoversandt.toLocaleString() + " versandt"}
                                       >
                                          {ex_days}
                                       </div>
                                    )}
                                 </td>

                                 <td className="projektstatus-termin" style={{ background: "#000", padding: "0 8px" }}>
                                    {item.eskalationspause && item.eskalationspause.text && (
                                       <div
                                          title={
                                             item.eskalationspause
                                                .text /* item.eskalationspause.datum.toLocaleDateString() */
                                          }
                                          style={
                                             item.eskalationspause.datum > new Date()
                                                ? { backgroundColor: "green" }
                                                : { backgroundColor: "#333" }
                                          }
                                       >
                                          {item.eskalationspause.datum > new Date() ? (
                                             <span>
                                                EP{" "}
                                                {Math.floor(
                                                   (item.eskalationspause.datum - new Date()) / 1000 / 3600 / 24,
                                                )}
                                             </span>
                                          ) : (
                                             <span>
                                                {item.eskalationspause.datum.toLocaleDateString().slice(0, -4)}
                                             </span>
                                          )}
                                       </div>
                                    )}
                                 </td>
                                 <td>
                                    <a
                                       target="_blank"
                                       className="projektstatus-linkbutton me-1"
                                       style={{ fontWeight: 600, fontSize: "16px" }}
                                       href={"/datenblatt?estateid=" + item.id}
                                    >
                                       {(item.objektbezeichnung
                                          ? item.objektnr_extern + " - " + item.objektbezeichnung.slice(0, -5)
                                          : item.objektnr_extern) + " ↗"}
                                    </a>
                                 </td>
                              </tr>
                           );
                        })}
                  </tbody>
               </table>
            </div>
         )}
      </div>
   );
}
